// extracted by mini-css-extract-plugin
module.exports = {"newUser":"NewUser-styles_newUser__8hnzc"};